import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*eslint n/no-unsupported-features/es-syntax: ["error", {version: "14.0"}] */
import { createNanoEvents } from 'nanoevents';
import { ReasonError } from "../protocol/index.js";
import { stringifyParams } from "../stringify-params/index.js";
var STATE = Symbol('state');
export var Channel = /*#__PURE__*/function () {
  // Unique channel identifier
  // static identifier = ''
  function Channel() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Channel);

    this.emitter = createNanoEvents();
    this.params = Object.freeze(params);
    this.initialConnect = true;
    this[STATE] = 'idle';
  }

  _createClass(Channel, [{
    key: "identifier",
    get: function get() {
      if (this._identifier) return this._identifier; // Use Action Cable identifiers as internal identifiers for channels

      this._identifier = stringifyParams(_objectSpread({
        channel: this.channelId
      }, this.params));
      return this._identifier;
    }
  }, {
    key: "channelId",
    get: function get() {
      return this.constructor.identifier;
    }
  }, {
    key: "state",
    get: function get() {
      return this[STATE];
    }
  }, {
    key: "attached",
    value: function attached(receiver) {
      if (this.receiver) {
        if (this.receiver !== receiver) {
          throw Error('Already connected to a different receiver');
        }

        return false;
      }

      this.receiver = receiver;
      return true;
    }
  }, {
    key: "connecting",
    value: function connecting() {
      this[STATE] = 'connecting';
    }
  }, {
    key: "connected",
    value: function connected() {
      if (this.state === 'connected') return;
      if (this.state === 'closed') return;
      this[STATE] = 'connected';
      var restored = false;

      if (this.initialConnect) {
        this.initialConnect = false;
        this.emit('connect', {
          reconnect: false,
          restored: restored
        });
      } else {
        this.emit('connect', {
          reconnect: true,
          restored: restored
        });
      }
    }
  }, {
    key: "restored",
    value: function restored() {
      if (this.state === 'connected') throw Error('Already connected');
      if (this.state !== 'connecting') throw Error('Must be connecting');
      this[STATE] = 'connected';
      var restored = true;
      var reconnect = true;
      this.initialConnect = false;
      this.emit('connect', {
        reconnect: reconnect,
        restored: restored
      });
    }
  }, {
    key: "disconnected",
    value: function disconnected(err) {
      if (this.state === 'disconnected' || this.state === 'closed') return;
      this[STATE] = 'disconnected';
      this.emit('disconnect', err);
    }
  }, {
    key: "closed",
    value: function closed(err) {
      if (this.state === 'closed') return;
      this[STATE] = 'closed';
      delete this.receiver;
      this.initialConnect = true;
      this.emit('close', err);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.state === 'idle' || this.state === 'closed') {
        return;
      }

      this.receiver.unsubscribe(this);
    }
  }, {
    key: "perform",
    value: function () {
      var _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, payload) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state === 'idle' || this.state === 'closed')) {
                  _context.next = 2;
                  break;
                }

                throw Error('Channel is not subscribed');

              case 2:
                return _context.abrupt("return", this.receiver.perform(this.identifier, action, payload));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function perform(_x, _x2) {
        return _perform.apply(this, arguments);
      }

      return perform;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.perform(undefined, payload));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function send(_x3) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "receive",
    value: function receive(msg, meta) {
      this.emit('message', msg, meta);
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      return this.emitter.on(event, callback);
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      var unbind = this.emitter.on(event, function () {
        unbind();
        callback.apply(void 0, arguments);
      });
      return unbind;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      var _this$emitter;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_this$emitter = this.emitter).emit.apply(_this$emitter, [event].concat(args));
    }
  }, {
    key: "ensureSubscribed",
    value: function ensureSubscribed() {
      if (this.state === 'connected') return Promise.resolve();

      if (this.state === 'closed') {
        return Promise.reject(Error('Channel is unsubscribed'));
      }

      return this.pendingSubscribe();
    } // This promise resolves when subscription is confirmed
    // and rejects when rejected or closed.
    // It ignores disconnect events.

  }, {
    key: "pendingSubscribe",
    value: function pendingSubscribe() {
      var _this = this;

      if (this._pendingSubscribe) return this._pendingSubscribe;
      this._pendingSubscribe = new Promise(function (resolve, reject) {
        var unbind = [function () {
          return delete _this._pendingSubscribe;
        }];
        unbind.push(_this.on('connect', function () {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          resolve();
        }));
        unbind.push(_this.on('close', function (err) {
          unbind.forEach(function (clbk) {
            return clbk();
          });
          reject(err || new ReasonError('Channel was disconnected before subscribing', 'canceled'));
        }));
      });
      return this._pendingSubscribe;
    }
  }]);

  return Channel;
}();